import { ActionType, createReducer, RootState } from 'typesafe-actions';
import { createSelector } from 'reselect';
import { ERROR_404_NOT_FOUND, ERROR_500_INTERNAL_SERVER_ERROR, UNHANDLED_SAGA_ERROR } from './actions';

type ErrorHookActions =
  | ActionType<typeof ERROR_404_NOT_FOUND>
  | ActionType<typeof ERROR_500_INTERNAL_SERVER_ERROR>
  | ActionType<typeof UNHANDLED_SAGA_ERROR>;

type ErrorRecordMetadata = {
  statusCode: 404 | 500;
  reasonDetails: string;
};

export const errorsHookReducer = createReducer<ErrorRecordMetadata[], ErrorHookActions>([])
  .handleAction(ERROR_404_NOT_FOUND, (state, { payload }) => {
    return [
      ...state,
      {
        statusCode: 404,
        reasonDetails: String(payload),
      },
    ];
  })
  .handleAction([ERROR_500_INTERNAL_SERVER_ERROR, UNHANDLED_SAGA_ERROR], (state, { payload }) => {
    return [
      ...state,
      {
        statusCode: 500,
        reasonDetails: String(payload),
      },
    ];
  });

const featureSelector = (store: RootState) => store.errorsHook;

export const checkIfThereIsErrors = createSelector(
  featureSelector,
  (state: ReturnType<typeof errorsHookReducer>) => state.length > 0,
);

export const checkIfThereIs404Error = createSelector(
  featureSelector,
  (state: ReturnType<typeof errorsHookReducer>) => state.some((r) => r.statusCode === 404),
);

export const checkIfThereIs500Error = createSelector(
  featureSelector,
  (state: ReturnType<typeof errorsHookReducer>) => state.some((r) => r.statusCode === 500),
);
